import React, { useState } from "react";
import { Link } from "gatsby";
import BlogCard from "./BlogCard";
import _ from "lodash";

const BlogPage = ({
  title,
  showAll,
  blogDescription,
  categoryLinkText,
  posts,
  tags,
  pageId,
  currentTag,
  inTagPage,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <React.Fragment>
      <header className="hero container-fluid pt-3 mt-5 pb-4 bg-primary pt-5 position-relative">
        <div className="row contained-xl justify-content-center">
          <div className="col-11 col-md-6 col-lg-7 mb-md-5 pb-lg-5">
            <h1 className="">
              {title.map(function (t, i) {
                if (i > 0) return <>{t}</>;
                else
                  return (
                    <span
                      className={i === 0 && title.length > 1 ? "h2 mb-0" : ""}
                    >
                      {t}
                      {i === 0 && title.length > 1 ? (
                        <span className="ml-2">
                          / <br />
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  );
              })}
            </h1>
            {blogDescription && <div className="lead">{blogDescription}</div>}
          </div>
          <div className="col-md-5 col-lg-2 offset-lg-1 mt-lg-5">
            {tags && (
              <div className="position-relative">
                <button
                  className={`btn btn-sm btn-outline-white d-block btn-block my-1 ${
                    open ? "active" : ""
                  } col-12`}
                  type="button"
                  onClick={() => setOpen(!open)}
                  onKeyDown={() => setOpen(!open)}
                >
                  {categoryLinkText}{" "}
                  <i
                    className={`ml-1 fa ${
                      open ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  />
                </button>
                {open && (
                  <div
                    className="d-block w-100 position-absolute overflow-auto px-3 bg-primary pb-3 rounded-bottom shadow-lg pt-3"
                    style={{ zIndex: "9999" }}
                  >
                    {showAll && (
                      <Link
                        className={`pb-1 small d-block mb-2 border-bottom border-white border-thin`}
                        to={`/blog/`}
                      >
                        Show All
                      </Link>
                    )}
                    {tags &&
                      tags.map(function (tag, index) {
                        if (currentTag !== tag) {
                          return (
                            <Link
                              className={`py-1 small d-block my-2 border-bottom border-white border-thin`}
                              to={`/tags/${_.kebabCase(tag)}`}
                              key={`tag-${index}`}
                            >
                              {tag}
                            </Link>
                          );
                        } else {
                          return "";
                        }
                      })}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </header>

      <section className="postlists container-fluid">
        <div className="row justify-content-center bg-secondary negative-margin  pt-4 pt-lg-0">
          <div className="col-md-12 col-lg-10 negative-margin_inner">
            <div className="row pb-5 contained-xl">
              {posts &&
                posts.map(function ({ node: post }, index) {
                  return (
                    <div
                      key={"block_" + pageId + "_" + index}
                      className="col-md-6 col-lg-4 col-xl-3 mb-4"
                    >
                      <BlogCard
                        featured_media={post.frontmatter.image}
                        title={post.frontmatter.title}
                        date={post.frontmatter.date}
                        excerpt={post.frontmatter.excerpt}
                        tag={post.frontmatter.tags}
                        slug={post.fields.slug}
                        readtime={post.timeToRead}
                        inTagPage={inTagPage}
                      />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default BlogPage;
